module.exports = __webpack_public_path__ + "img/exact_rounded.2b43406.svg";